<div class="app-container">
  <app-header class="header"></app-header>
  <!--TODO: Revert after ZOZ feature approve-->
  <div *ngIf="!userRole.isZOZUser" class="main">
    <!-- <div class="main"> -->
    <app-sidebar [items]="navItems" class="sidebar"></app-sidebar>
    <div class="content-container">
      <div class="content-header">
        <app-breadcrumbs
          [items]="navItems"
          class="breadcrumbs"
        ></app-breadcrumbs>
        <div [class.two-items]="showRedistributions" [class.redistributions-state]="isRedistributions"  class="title-container">
          <app-page-title [items]="navItems" class="page-title"/>
          <div class="actions-holder">
            <div>
              <div *ngIf="isRedistributions">
                <app-state-redistribution-switch />
              </div>
            </div>
            <div class="flex flex-row">
              <div class="actions-item" *ngIf="showRegistry">
                <app-toggle-switch
                    class="toggle-switch"
                />
                <app-state-switch (onAction)="onAppContentChange($event)"/>
              </div>
              <div class="actions-item" *ngIf="showRedistributions">
                <app-toggle-switch
                    [isDisabled]="showTable"
                />
              </div>
              <div class="actions-item" *ngIf="showCreateQuarantine">
                <button class="button" (click)="redirectToCreateQuarantine()" >Розмістити у карантин</button>
              </div>
              <div class="actions-item" *ngIf="isRedistributionsRequest">
                <button class="button" (click)="redirectToCreateredistributionRequest()" >Створити запит</button>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="content">
        <ng-container *ngIf="showRegistry">
          <router-outlet *ngIf="showTable" name="table"></router-outlet>
          <router-outlet *ngIf="!showTable" name="list"></router-outlet>
        </ng-container>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
